import styled from 'styled-components';
import {device} from 'styled/device';

export const Wrapper = styled.div`
  margin-top: 24px;
  max-width: 562px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
  row-gap: 24px;
`;

export const Title = styled.h1`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
  margin: 0 0 16px 0;

  @media (min-width: ${device.tablet}) {
    font-size: 28px;
    line-height: 36px;
  }
`;

export const Subtitle = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#6B7280'};
`;

export const ContentBoxInfo = styled.div`
  margin: 0 auto 24px;
  @media (min-width: ${device.tablet}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const FormContainer = styled.div`
  margin-top: 24px;
  width: 100%;
  max-width: 522px;
`;

export const EmailVerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 327px;
  margin: 0 auto;
`;

export const EmailVerificationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const EmailVerificationTitle = styled.h2`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const EmailVerificationSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#777e91'};
  margin: 0;
  text-align: center;
  width: 100%;
`;
